<template>
  <i-modal
    :value="show"
    title="组题方式"
    footer-hide
    @on-visible-change="onVisibleChange">
    <div class="mode-list">
      <i-button type="primary" @click="selectComQuestionMode('productCode')">按型号组题</i-button>
      <i-button type="primary" @click="selectComQuestionMode('productGroup')">按产品组组题</i-button>
    </div>
  </i-modal>
</template>

<script>
export default {
  name: 'ComQuestionMode',
  props: {
    show: { type: Boolean, required: true },
  },
  methods: {
    selectComQuestionMode(mode) {
      this.$emit('select-com-question-mode', mode);
    },
    onVisibleChange(flag) {
      this.$emit('visible-change', flag);
    },
  },
};
</script>

<style lang="less" scoped>
.mode-list {
  display: flex;
  justify-content: center;

  /deep/ .ivu-btn {
    margin-right: 12px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
